import axios from "axios";

export interface DocumentClassification {
  id: string | null;
  title: string;
  assignedUsers: string[];
  assignedRoles: string[];
}

interface DocumentClassificationApi {
  list(): Promise<DocumentClassification[]>;
  add(documentClassification: DocumentClassification): Promise<string>;
  edit(documentClassification: DocumentClassification): Promise<void>;
  delete(documentClassification: DocumentClassification): Promise<void>;
}

export const documentClassificationApi: DocumentClassificationApi = {
  async list() {
    const result = (await axios.get("/api/document-classifications")).data
    if (result) {
      return result.map(
        (v: DocumentClassification) =>
          ({
            ...v,
            assignedUsers: v.assignedUsers ? v.assignedUsers  : [],
            assignedRoles: v.assignedRoles ? v.assignedRoles  : [],
          } as DocumentClassification)
      );

    }
    return []

  },
  async add(documentClassification: DocumentClassification) {
    return (await axios.post("/api/document-classifications", documentClassification)).data
  },
  async edit(documentClassification: DocumentClassification) {
    return (await axios.put(`/api/document-classifications/${documentClassification.id}`, documentClassification)).data
  },
  async delete(documentClassification: DocumentClassification) {
    return await axios.delete(`/api/document-classifications/${documentClassification.id}`);
  },
};

